import {updateMask} from '@js/utils/update-mask'

const data = {
	elements: {
		$section: $('.js-data'),
	},

	init() {
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.$section,
				start:               'top bottom',
				end:                 'top top',
				scrub:               true,
				invalidateOnRefresh: true,
				onUpdate:            () => {
					updateMask(this.elements.$section[0], 'data-mask')
				},
			},
		}).to(this.elements.$section, {
			'--mask-progress': 1,
		}, 0)
	},
}
export default data
